///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm_import = abcsetup.three_pm_import || {};
abcsetup.three_pm_import.edit = abcsetup.three_pm_import.edit || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.task = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm_import.edit = {
    init: function() {
        require('jscroll');
        // Remove button clicked
        $(document).on('click', 'button.remove-item', function (event) {
            var item = $(this).closest('.card-header').data('item');
            abcsetup.three_pm_import.edit._removeItem(item, event);
            return false;
        });
        // Remove image button clicked
        $(document).on('click', 'button.remove-image', function (event) {
            const _this = $(this);
            abcsetup.alerts.confirm('Delete Image', 'Are you sure you want to delete this image?', function (resp) {
                if (!resp) {
                    return;
                }
                var image = _this.data('id');
                abcsetup.three_pm_import.edit._removeImage(image, event);
                return false;
            });
        });

        // Accordion item clicked
        $('[data-toggle="collapse"]').off('click.accordion_item').on('click.accordion_item', function() {
            $('#item-accordion').data('item', $($(this).attr("href")).attr('id'));
        });

        // Accordion open/closed
        $(document).on('show.bs.collapse', '.collapse', function() {
            console.log('show');
            $('#item-accordion').data('showing', true).data('item', $(this).attr('id'));
            $(this).parent().find(".fa").toggleClass("down");

        }).on('hide.bs.collapse', '.collapse', function(event) {
            console.log('hide');
            // NOTE : Adding this disables the click event on the delete button
            // Prevent other items from collapsing when opening a new one
            // if ($('#item-accordion').data('showing') && $('#item-accordion').data('item') != $(this).attr('id')) {
            //     event.preventDefault();
            //     return;
            // }

            $('#item-accordion').data('showing', false);
            $(this).parent().find(".fa").toggleClass("down");
        });


        $('ul.pagination').hide();
        $(function() {
            $('.scrolling-pagination').jscroll({
                autoTrigger: true,
                padding: 0,
                nextSelector: '.pagination li.active + li a',
                contentSelector: 'div.scrolling-pagination',
                callback: function() {
                    $('ul.pagination').remove();
                }
            });
        });
    },

    /**
     * Remove the item
     */
       _removeItem: function (item) {
        // abcsetup.alerts.show('Approving', 'Item: '+item);
        console.log('clicked')
        var task = $("#CurrentTaskId").val();
        console.log('Removing', 'Item: ' + item + ', Task: ' + task);
        axios.post('/api/three_pm_import/remove_item/' + item, {task: task}).then(response => {
           // show message item removed
            if ( response.data.item ) {
                if ( response.data.message_type == "danger" ) {
                    // remove message is shown in a danger message
                    $("div.card-header[data-item='"+response.data.item+"']").closest('.card').animate({right: '110%'},500,'linear',function(){
                        abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                        $(this).remove();
                    });
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
        });
    },
    /**
     * Remove the item image
     */
        _removeImage: function (image) {
        console.log('Removing', 'Image: ' + image);
        axios.post('/api/three_pm_import/remove_image/' + image).then(response => {
           // show message image removed
            if ( response.data.image ) {
                if ( response.data.message_type == "danger" ) {
                    // remove message is shown in a danger message
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.image ? response.data.image : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                    $("button.remove-image[data-id='"+response.data.image+"']").remove();
                    $("img[data-image='"+response.data.image+"']").remove();
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.image ? response.data.image : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
        });
    },
}
